import React from 'react';
import { IconSoftwareError } from '@sfx/icons';
import Notification from '../../Basic/Notification';
export var notifyErrorToast = function notifyErrorToast(message, error) {
  if (error) {
    console.error(error);
  }

  Notification.error({
    description: message,
    icon: /*#__PURE__*/React.createElement(IconSoftwareError, {
      size: "24"
    }),
    duration: 4
  });
};